"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchAndDownloadFile = fetchAndDownloadFile;
exports.downloadFileAttributeCallback = downloadFileAttributeCallback;

var _fetchPonyfill2 = _interopRequireDefault(require("fetch-ponyfill"));

var _jsFileDownload = _interopRequireDefault(require("js-file-download"));

var _nativePromiseOnly = _interopRequireDefault(require("native-promise-only"));

var _Formio = _interopRequireDefault(require("../Formio"));

var _errorMessageIdGetters = require("./errorMessageIdGetters");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _fetchPonyfill = (0, _fetchPonyfill2.default)({
  Promise: _nativePromiseOnly.default
}),
    fetch = _fetchPonyfill.fetch;

function fetchAndDownloadFile(url, fetchOptions, fileName, type) {
  return fetch(url, fetchOptions).then(function (res) {
    if (!res.ok) {
      var messageId = (0, _errorMessageIdGetters.getFileErrorMessageIdByStatus)(res.status);

      _Formio.default.handleErrorWithOuterErrorHandler(messageId);
    } else {
      return res.blob();
    }
  }).then(function (file) {
    if (file) {
      (0, _jsFileDownload.default)(file, fileName, type);
    }
  });
}

function downloadFileAttributeCallback(event, anchor) {
  if (event) {
    event.preventDefault();
  }

  if (anchor) {
    var href = anchor.href,
        anchorDataset = anchor.dataset;
    var type = anchorDataset.type,
        originalname = anchorDataset.originalname;
    var options = {
      method: 'GET',
      mode: 'cors',
      headers: {
        Accept: '*/*'
      },
      credentials: 'include',
      responseType: 'blob'
    };
    fetchAndDownloadFile(href, options, originalname, type);
  }
}